import React from 'react'
import './LoaderScr.css'

const LoaderScr = ({isLoading,isShowdownload}) => {
  return (
    <>    {isLoading ?
        <div className="my-component">
        <div className="my-component-loader-overlay">
         <div className="my-component-loader"></div>
        {isShowdownload == true && <p className="ms-2 mt-2" style={{color:'white',fontSize:'18px'}}>Downloading...</p>}
       </div>
   </div>
        :null}
        </>

  
  )
}

export default LoaderScr